<div *ngIf="entity" style="gap: 16px;
margin-bottom:16px;display: flex;
flex-wrap: wrap;place-content: stretch center!important;
align-items: center!important;" class=" m-t-0" [ngClass]="{'p-t-16 m-t-8 p-b-8': home == true}" fxLayout="row wrap" fxLayoutAlign="center center">
  <ng-container *ngFor="let banner of entity.banner; let e = index">
    <ng-container *ngIf="((home && banner.inHome) || (!home && banner.inOtherPages)) && ((onlyBig && banner.big) || (onlyBig != true && banner.big != true ))">
      <div class="banner-content matero-col" fxFlex="100" [fxFlex.gt-sm]="(home == true  && banner.big != true) ? 50 : 100" [fxFlex.gt-lg]="(home == true  && banner.big != true) ? 33 : 100" style="padding:0px;width: 100%" [ngClass]="{'big': banner.big, 'entityColor': banner.backgroundEntityColor }">
        <a href="{{banner.url}}" target="{{ (banner.urlNewPage) ? 'new': '_self' }}" *ngIf="banner.url && banner.image">
          <img class="pointer" src="{{ sharedService.getImage(banner.image) }}" title="{{ banner.name }}" alt="{{ banner.description }}" width="100%">     
        </a>
        <img *ngIf="!banner.url && banner.image" src="{{ sharedService.getImage(banner.image) }}" title="{{ banner.name }}" alt="{{ banner.description }}" width="100%">   
        
        <div class="banner-info"  *ngIf="banner.textDescriptionOverlap || (banner.buttonTextOverlap && banner.buttonLinkOverload)"
          [style.align-items]="banner.align === TYPE_ALIGN_RIGHT ? 'right' : (banner.align === TYPE_ALIGN_LEFT) ? 'left' : 'center'" 
          [style.text-align]="banner.align === TYPE_ALIGN_RIGHT ? 'right' : (banner.align === TYPE_ALIGN_LEFT) ? 'left' : 'center'">
          
          <div class="banner-description"
            
            *ngIf="banner.textDescriptionOverlap"
            [innerHTML]="getSanitizedHtml(banner.textDescriptionOverlap)">
          </div>
          
          <a mat-button class="banner-button mat-flat-button" href="{{banner.buttonLinkOverload}}" *ngIf="banner.buttonTextOverlap && banner.buttonLinkOverload"
             target="{{ (banner.urlNewPageOverlap) ? 'new': '_self' }}">
            {{banner.buttonTextOverlap}}
          </a>
          
        </div>
      </div>
    </ng-container>  
  </ng-container>
</div>